var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { I18NLink } from "../I18N";
import { actions } from "../BasicReducer";
import { store } from "../store";

export class SiteName extends Component {
  render() {
    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Helmet, {
        titleTemplate: `%s • ${this.props.siteName}`,
        meta: [{ 'char-set': 'utf-8' }, { name: 'description', content: 'Uwazi docs' }] }
      ), /*#__PURE__*/
      _jsx(I18NLink, {
        to: "/",
        onClick: () => store.dispatch(actions.set('library.sidepanel.view', 'library')) }, void 0,

      this.props.siteName
      )
      ));

  }
}





export function mapStateToProps(state) {
  return { siteName: state.settings.collection.get('site_name') };
}

export default connect(mapStateToProps)(SiteName);